export default "__VITE_ASSET__9VN9HCnA__"